import { render } from "./RequestShiftFormDialog.vue?vue&type=template&id=bce07f98&scoped=true&ts=true"
import script from "./RequestShiftFormDialog.vue?vue&type=script&lang=ts"
export * from "./RequestShiftFormDialog.vue?vue&type=script&lang=ts"

import "./RequestShiftFormDialog.vue?vue&type=style&index=0&id=bce07f98&scoped=true&lang=scss"
import "./RequestShiftFormDialog.vue?vue&type=style&index=1&id=bce07f98&lang=scss"

import exportComponent from "/builds/maqqie/maqqie-client-portal/clientportal-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bce07f98"]])

export default __exports__